import { Tracking } from '../../../analytics/atl-analytics/tracking';

import { ufoEventGetRecaptcha } from './ufo-events';

export const getRecaptcha = async (
	email: string,
	executeRecaptcha: ((action?: string) => Promise<string>) | undefined,
) => {
	ufoEventGetRecaptcha.start({
		webPlatform: 'bxp-ui',
	});

	const shouldSkipRecaptcha = (email: string) => {
		const botTestPattern =
			/(bottest@usersinbuckets.com|bottest@atl-paid-dev.com|bottest@bxpwpi.com)$/;
		return botTestPattern.test(email);
	};

	let gRecaptchaResponse = '';
	const skipRecaptcha = shouldSkipRecaptcha(email);

	if (skipRecaptcha) {
		gRecaptchaResponse = 'reCaptcha';
	} else {
		if (!executeRecaptcha) {
			ufoEventGetRecaptcha.failure({
				customData: {
					gRecaptchaResponse: gRecaptchaResponse ?? 'none',
					executeRecaptchaExists: Boolean(executeRecaptcha),
					reactComponent: 'getRecaptcha',
					analyticsEvent: 'notFound',
				},
				error: new Error('executeRecaptcha not found'),
			});
			console.log('Execute recaptcha not yet available');
			return;
		}
		try {
			gRecaptchaResponse = await executeRecaptcha('userSignup');

			ufoEventGetRecaptcha.success({
				customData: {
					gRecaptchaResponse: gRecaptchaResponse ?? 'none',
					executeRecaptchaExists: Boolean(executeRecaptcha),
					reactComponent: 'getRecaptcha',
					analyticsEvent: 'succeeded',
				},
			});
		} catch (error) {
			ufoEventGetRecaptcha.failure({
				customData: {
					gRecaptchaResponse: gRecaptchaResponse ?? 'none',
					executeRecaptchaExists: Boolean(executeRecaptcha),
					reactComponent: 'getRecaptcha',
					analyticsEvent: 'errored',
				},
				error,
			});

			console.log('Error executing recaptcha', error);
			Tracking.trackEvent('bxp.formCloudSignup.reCaptchaError', {
				eventContainer: 'bxp-ui-signup',
			});
			return;
		}
	}

	return gRecaptchaResponse;
};
